import { Element as SlateElement } from 'slate';
import { RenderElementProps } from 'slate-react';
import { ReferenceTable } from './ReferenceTable';
import { TaggableTable } from './TaggableTable';
import { useEditorMode } from 'app/state/contexts/EditorContext';

interface TableRendererProps {
  props: RenderElementProps;
  withComments?: boolean;
  withTags?: boolean;
  readOnly?: boolean;
}

export const TableRenderer = ({ props, withComments, withTags, readOnly }: TableRendererProps) => {
  const { isTaggingMode } = useEditorMode();

  if (isTaggingMode) {
    return <TaggableTable {...props} element={props.element as SlateElement & { uuid: string }} withComments={withComments} withTags={withTags} />;
  }
  return <ReferenceTable {...props} readOnly={readOnly} />;
};
